/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { MenuTools, Wrap } from './styles';

import { ToolsIcon } from './components/Icons';

import Buffer from '../Buffer';
import Clip from '../Clip';
import Dissolve from '../Dissolve';
import Erase from '../Erase';
import Intersect from '../Intersect';
import Merge from '../Merge';
import SelectFeature from '../SelectFeature';
import Union from '../Union';

import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

/**
 * Ferramenta de Analise
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @returns Um menu onde esta a ferramenta buffer
 */
export const AnalysisTools = ({ mapContext, isActive, setIsActive }) => {    
  const [activeTool, setActiveTool] = useState(null);

  // Estados de SUBMENU
  const [anchorToolOptions, setAnchorToolOptions] = useState(null);
  
  useEffect(() => {
    if (!isActive) setAnchorToolOptions(null);
  }, [isActive]);
  
  const { getElement, activeModule } = useModule();    

  const handleActiveTool = (toolName) => {
    setActiveTool(activeTool === toolName ? null : toolName);
  };

  // Observando se a ferramenta está ativa
  useEffect(() => {
    if (isActive) {      
      setActiveTool(null);
    }
  }, [isActive]);

  return (
    <Wrap>      
      <ButtonTooltip
        tooltip={AnalysisTools.properties.alias}
        description={AnalysisTools.properties.description}
        onClick={(e) => {          
          setIsActive(!isActive);
          setAnchorToolOptions(anchorToolOptions ? null : e.currentTarget);
        }}
        tooltipDisabled={isActive}
        active={isActive}
      >
        <ToolsIcon />
      </ButtonTooltip>
      <MenuTools 
        className={`${
            isActive && 'active'
        }`}
      >
    
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.buffer !== false && (
            <div className="tool">
              <Tooltip>
                <Buffer
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-BUFFER'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-BUFFER')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.featureSelection !== false && (            
            <div className="tool">
              <Tooltip>
                <SelectFeature
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-SELECT-FEATURE'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-SELECT-FEATURE')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.intersect !== false && (
            <div className="tool">
              <Tooltip>
                <Intersect
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-INTERSECT'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-INTERSECT')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.merge !== false && (
            <div className="tool">
              <Tooltip>
                <Merge
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-MERGE'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-MERGE')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.dissolve !== false && (
            <div className="tool">
              <Tooltip>
                <Dissolve
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-DISSOLVE'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-DISSOLVE')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.union !== false && (
            <div className="tool">
              <Tooltip>
                <Union
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-UNION'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-UNION')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.erase !== false && (
            <div className="tool">
              <Tooltip>
                <Erase
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-ERASE'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-ERASE')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(AnalysisTools.properties.id)?.configuracao.clip !== false && (
            <div className="tool">
              <Tooltip>
                <Clip
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-CLIP'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-CLIP')}
                />
              </Tooltip>
            </div>
          )
        }
        
      </MenuTools>
    </Wrap>
  );
};

AnalysisTools.properties = {
  id: 'CPN-TB-A-ANALYSIS-TOOLS',
  alias: 'Ferramentas de Análise',
  description:
    'Conjunto de ferramentas de geoprocessamento.',
  configurable: true,
};

export default AnalysisTools;
